"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.sessionTools = void 0;
const async_storage_1 = __importDefault(require("@react-native-async-storage/async-storage"));
const uuid_1 = require("uuid");
const SESSION_ID_KEY = 'sessionId';
const SESSION_LAST_ACTIVITY_TIME_KEY = 'sessionExpiration';
const SESSION_DURATION_MINUTES = 30;
const DIF_MS = SESSION_DURATION_MINUTES * 60 * 1000;
const getOrUpdateSessionId = async () => {
    const value = await async_storage_1.default.getItem(SESSION_ID_KEY);
    if (!!value) {
        const isExpired = await isSessionExpired();
        return isExpired ? createSessionId() : value;
    }
    const newSessionId = await createSessionId();
    return newSessionId;
};
const recordActivity = async () => {
    // update the sessionId, if needed, before recording activity
    await getOrUpdateSessionId();
    const now = Date.now();
    await async_storage_1.default.setItem(SESSION_LAST_ACTIVITY_TIME_KEY, now.toString());
    return now;
};
const getLastActivity = async () => {
    const time = await async_storage_1.default.getItem(SESSION_LAST_ACTIVITY_TIME_KEY);
    if (!!time) {
        return +time;
    }
    return null;
};
const isSessionExpired = async () => {
    const lastActivity = await getLastActivity();
    if (!!lastActivity) {
        const currentTime = Date.now();
        return currentTime - lastActivity > DIF_MS;
    }
    return true;
};
const createSessionId = async () => {
    const sessionId = (0, uuid_1.v4)();
    await async_storage_1.default.setItem(SESSION_ID_KEY, sessionId);
    return sessionId;
};
exports.sessionTools = {
    getOrUpdateSessionId,
    recordActivity,
    getLastActivity,
};
